import { useState } from "react";
import { Atom, Film, FlaskConical, ShieldCheck, Server, Plane, ArrowRight } from "lucide-react";
import { useTheme } from "../context/ThemeContext";
import { ScenePillar } from "../shared/Scene";

const steps = [
  { icon: Atom, label: "Nucleus", caption: "AI Discovery", detail: "AI-powered content discovery, route-specific programming, real-time insights." },
  { icon: Film, label: "Studios", caption: "Licensing", detail: "Direct relationships with the majors, OTT partnerships, regional distributors." },
  { icon: FlaskConical, label: "AeroLab", caption: "Processing", detail: "Editing, encoding, multi-language subtitles, metadata — TPN Gold Mumbai." },
  { icon: ShieldCheck, label: "QC", caption: "Compliance", detail: "Automated validation, regulatory checks, TPN-grade quality control." },
  { icon: Server, label: "Delivery", caption: "IFE & AeroHub", detail: "Encrypted delivery, real-time status, wireless streaming." },
  { icon: Plane, label: "Onboard AI", caption: "Feedback", detail: "Recommendations, passenger behaviour telemetry, continuous learning loop." },
];

const outcomes = [
  { label: "Faster deliveries", value: "50%" },
  { label: "TPN-grade accuracy", value: "99%+" },
  { label: "Days to launch", value: "90" },
];

const SlideFast = () => {
  const { isDark } = useTheme();
  const [active, setActive] = useState(null);

  const visual = (
    <div>
      <div
        className={`relative rounded-2xl p-6 ${
          isDark ? "bg-white/[0.03] border border-white/10" : "bg-white border border-black/10"
        }`}
      >
        <div className="flex items-center gap-1">
          {steps.map((s, i) => {
            const Icon = s.icon;
            const isOn = active === i;
            const isLast = i === steps.length - 1;
            return (
              <div key={i} className="flex items-center gap-1 flex-1 last:flex-none">
                <button
                  type="button"
                  onClick={() => setActive(isOn ? null : i)}
                  data-testid={`process-step-${i}`}
                  className="flex-1 flex flex-col items-center gap-2 group min-w-0"
                >
                  <div
                    className="w-11 h-11 rounded-full flex items-center justify-center transition-transform"
                    style={{
                      backgroundColor: isOn
                        ? "#F2A900"
                        : isDark
                        ? "rgba(255,255,255,0.06)"
                        : "rgba(0,0,0,0.05)",
                      color: isOn ? "#1d1d1f" : isDark ? "#f5f5f7" : "#1d1d1f",
                      transform: isOn ? "scale(1.10)" : "scale(1)",
                    }}
                  >
                    <Icon className="w-5 h-5" />
                  </div>
                  <div className={`text-[12px] font-semibold ${isDark ? "text-white/85" : "text-[#1d1d1f]"}`}>{s.label}</div>
                  <div className={`text-[10px] ${isDark ? "text-white/45" : "text-black/45"}`}>{s.caption}</div>
                </button>
                {!isLast && (
                  <ArrowRight
                    className="w-4 h-4 flex-shrink-0 mb-8"
                    style={{ color: "#F2A900" }}
                    aria-hidden="true"
                  />
                )}
              </div>
            );
          })}
        </div>

        {active !== null && (
          <p className={`mt-6 pt-5 border-t k-body ${
            isDark ? "border-white/10 text-white/75" : "border-black/10 text-black/70"
          }`}>
            {steps[active].detail}
          </p>
        )}
        {active === null && (
          <p className={`mt-6 pt-5 border-t text-[13px] italic ${
            isDark ? "border-white/10 text-white/40" : "border-black/10 text-black/40"
          }`}>
            Tap a step to see how it works.
          </p>
        )}
      </div>
    </div>
  );

  return (
    <ScenePillar
      eyebrow="Fast — Media"
      headline="Studio to Seat,"
      accentLine="in one loop."
      accent="#F2A900"
      lead="A closed-loop supply chain. AI-guided. Learns from every flight — and gets faster with each cycle."
      visual={visual}
      outcomes={outcomes}
    />
  );
};

export default SlideFast;
